﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function extendedFactsBlock(context) {
  let aniTick = false;

  const setBackgroundImageSizeClass = function() {
    if (!aniTick) {
      window.requestAnimationFrame(function() {
        const listWidth = context.getBoundingClientRect().width;

				if (listWidth >= 850 && !context.classList.contains('extendedfactsblock__toplist--large')) {
          context.classList.add('extendedfactsblock__toplist--large');
          context.classList.remove('extendedfactsblock__toplist--medium');
          context.classList.remove('extendedfactsblock__toplist--small');
        } else if (listWidth >= 700 && listWidth < 850 && !context.classList.contains('extendedfactsblock__toplist--medium')) {
          context.classList.remove('extendedfactsblock__toplist--large');
          context.classList.add('extendedfactsblock__toplist--medium');
          context.classList.remove('extendedfactsblock__toplist--small');
        } else if (listWidth < 700 && !context.classList.contains('extendedfactsblock__toplist--small')) {
          context.classList.remove('extendedfactsblock__toplist--large');
          context.classList.remove('extendedfactsblock__toplist--medium');
          context.classList.add('extendedfactsblock__toplist--small');
        }

        aniTick = false;
      });
    }

    aniTick = true;
  };

  function init() {
    setBackgroundImageSizeClass();
    window.addEventListener('resize', setBackgroundImageSizeClass);
    window.addEventListener('orientationchange', setBackgroundImageSizeClass);
  }

  return {
    init
  };
}

controller.add('extended-facts-block', extendedFactsBlock);